define("settings/components/navigation-list-item", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <li class="tAC--sidebar__item" ...attributes>
    {{#if @linkTo}}
      <LinkTo @route={{@linkTo}} class={{concat-classes "tAC--sidebar__link" @qaClass}}>
        {{@title}}
      </LinkTo>
    {{else}}
      {{@title}}
    {{/if}}
  </li>
  */
  {
    "id": "bTD28RHF",
    "block": "[[[11,\"li\"],[24,0,\"tAC--sidebar__item\"],[17,1],[12],[1,\"\\n\"],[41,[30,2],[[[1,\"    \"],[8,[39,1],[[16,0,[28,[37,2],[\"tAC--sidebar__link\",[30,3]],null]]],[[\"@route\"],[[30,2]]],[[\"default\"],[[[[1,\"\\n      \"],[1,[30,4]],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[30,4]],[1,\"\\n\"]],[]]],[13]],[\"&attrs\",\"@linkTo\",\"@qaClass\",\"@title\"],false,[\"if\",\"link-to\",\"concat-classes\"]]",
    "moduleName": "settings/components/navigation-list-item.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});